import { environment } from '../../environments/environment';
import { IMenuOption } from '../models';

export enum FILE_STATUS {
  CREATED = 0,
  PENDING,
  PROCESSED,
  DELETED
}

export class AppConstants {
  // LOCAL
  static API_URL: string = environment.apiUrl;
  // DEV
   //static API_URL: string = 'http://localhost:50293/';


  public static get GetMenu(): IMenuOption[] { return this.MENU };

  public static GetPermissionType(_type: number): string {
    let type = '';

    switch (_type) {
      case 0: {
        type = 'Lectura';
        break;
      }
      case 1: {
        type = 'Modificación';
        break;
      }
    }

    return type;
  }



  public static GetError(_error: any): string {

    const JOINED_ERROR = _error?.Error?.Message || _error?.error?.Error?.Message || _error?.error || _error;

    if (typeof JOINED_ERROR === 'string') return JOINED_ERROR;
    
    return JSON.stringify(_error);
  }





  private static MENU = [
    {
      Name: 'Inicio',
      Route: '/home',
      Icon: 'fa fa-home',
      Children: [],
      Selected: true,
      Type: 1,
      RequiredPerm: 'V_Home',
      Visible: true
    },
    ///////////////MATERIALES////////////////
    {
      Name: 'Reportes',
      Route: '/reports-crud',
      Icon: 'fa fa-file-o title parent-icon',
      Children: [
      ],
      Selected: false,
      Type: 1,
      RequiredPerm: 'AccReports',
      Visible: false
    },
    {
      Name: 'Compañías',
      Route: '/companies',
      Icon: 'fa fa-building-o title',
      Children: [],
      Selected: false,
      Type: 1,
      RequiredPerm: 'V_AccCmp',
      Visible: true
    },
    {
      Name: 'Aplicaciones',
      Route: '/applications',
      Icon: 'fa fa-th-large title',
      Children: [],
      Selected: false,
      Type: 1,
      RequiredPerm: 'V_AccCmp',
      Visible: true
    },
    ///////////////PREFERENCIALES GENERALES////////////////
    {
      Name: 'Configuraciones',
      Route: '',
      Icon: 'fa fa-sliders fa-lg title parent-icon',
      Children: [
        {
          Name: 'Usuarios',
          Route: '/users',
          Icon: 'fa fa-cogs subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: 'V_Acc_Usu',
          Visible: true
        },
        {
          Name: 'Asignaciones',
          Route: '/user-assigns',
          Icon: 'fa fa-key subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: 'V_AccAss',
          Visible: true
        },
        {
          Name: 'Conexiones',
          Route: '/connections',
          Icon: 'fa fa-server subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: 'V_AccConn',
          Visible: true
        },
        {
          Name: 'Usuarios de Reportes',
          Route: '/report-users',
          Icon: 'fa fa-id-badge subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: 'V_Acc_RptUsu',
          Visible: true
        },
      ],
      Selected: false,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
    {
      Name: 'Salir',
      Route: '/logout',
      Icon: 'fa fa-sign-out fa-lg title parent-icon',
      Children: [],
      Selected: false,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
  ];

}

export const Menu = [
  {
    Name: 'Inicio',
    Path: 'home/',
    Icon: 'fa fa-home',
    Selected: true,
  },
  // {
  //   Name: 'Carga de archivos',
  //   Path: 'uploads',
  //   Icon: 'fa fa-upload',
  //   Selected: false,
  //   RequiredKey: '2',
  // },
  {
    Name: 'Archivos',
    Path: 'file-manager',
    Icon: 'fa fa-files-o',
    Selected: false,
    RequiredKey: '2',
  },
  {
    Name: 'Bitácora',
    Path: 'binnacle',
    Icon: 'fa fa-table',
    Selected: false,
    RequiredKey: '2',
  },
  {
    Name: 'Administración',
    Path: '',
    Icon: 'fa fa-cog',
    Selected: false,
    RequiredKey: '4',
    Children: [
      {
        Name: 'Usuarios',
        Path: 'users',
        Icon: 'fa fa-check',
        Selected: false,
        RequiredKey: '10',
      },
      {
        Name: 'Asignaciones',
        Path: 'user-assigns',
        Icon: '',
        Selected: false,
        RequiredKey: '12',
      },
      {
        Name: 'Conexiones',
        Path: 'conections',
        Icon: '',
        Selected: false,
        RequiredKey: '12',
      }
    ],
    Action: {},
  },
  {
    Name: 'Salir',
    Path: 'login',
    Icon: 'fa fa-sign-out',
    Selected: false,
  },
];

//#region Intereses
export const WeekDays = [
  { id: 1, name: 'Do', checked: false },
  { id: 2, name: 'Lu', checked: false },
  { id: 3, name: 'Ma', checked: false },
  { id: 4, name: 'Mi', checked: false },
  { id: 5, name: 'Ju', checked: false },
  { id: 6, name: 'Vi', checked: false },
  { id: 7, name: 'Sa', checked: false },
]

export const statusLog = [
  { key: '0', value: 'Todos' },
  { key: '1', value: 'Pendiente' },
  { key: '2', value: 'Enviando' },
  { key: '3', value: 'Enviado' },
  { key: '4', value: 'Error' }
];

export enum sendTypes {
  SinSeleccion = '',
  RangoPorFecha = '1',
  Todos = '2',
  PorProveedor = '3'
};

export enum ReportType {
  Company = 1,
  BusinessPartner = 2
}

export enum ReportSubType {
  Company = 1,
  BusinessPartner = 2,
  BusinessPartnerInternal = 3,
  BusinessPartnerSupplier = 4
}
//#endregion
